import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem,
  transitionFromId as baseTransitionFromId,
  statistic as baseStatistic,
  stateMachineStatistic as baseStateMachineStatistic,
  request
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of services based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('services', page, itemPerPage, search, order, scheme);
}

/**
 * Get a list of phone services (services with a phone package) based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function phoneIndex(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  let finalSearch = {};
  if(search) {
    Object.assign(finalSearch, search);
  }
  Object.assign(finalSearch, {
    state: "active,termination_waiting,termination_scheduled,termination",
    phone_package_order: true
  })
  return baseIndex('services', page, itemPerPage, finalSearch, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getFromId(id) {
  return baseGetFromId('services', id);
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getIdentificationFromId(id) {
  return baseGetFromId('services', id, 'identification');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getDependencyFromId(id) {
  return baseGetFromId('services', id, 'dependency');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getTechnicalDataFromId(id) {
  return baseGetFromId('services', id, 'technical_data');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getPublicTechnicalDataFromId(id) {
  return baseGetFromId('services', id, 'public_technical_data');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getContractsFromId(id) {
  return baseGetFromId('services', id, 'contract');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getPhonePackageApiFromId(id) {
  return baseGetFromId('services', id, 'phone_package_api');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getPhonePackageOrderFromId(id) {
  return baseGetFromId('services', id, 'phone_package_order');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getPhonePackageConsumptionFromId(id) {
  return baseGetFromId('services', id, 'phone_package_consumption');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getDataRechargeFromId(id) {
  return baseGetFromId('services', id, 'data_recharge');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getSpecificPhonePriceListFromId(id) {
  return baseGetFromId('services', id, 'specific_phone_price_list');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getAmendmentFromId(id) {
  return baseGetFromId('services', id, 'amendment');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getNewAmendmentFromId(id) {
  return baseGetFromId('services', id, 'new_amendment');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getCentreonConfigurationFromId(id) {
  return baseGetFromId('services', id, 'centreon_configuration');
}

/**
 * Get a single service based on his ID
 *
 * @param id the of the service requested
 */
export function getPhoneSystemReportingConfigurationFromId(id) {
  return baseGetFromId('services', id, 'phone_system_reporting_configuration');
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

 /**
  * Edit a single service based on his ID
  *
  * @param id the of the service requested
  * @param data the new data of the service
  */
 export function editFromId(id, data) {
   return baseEditFromId('services', id, data);
 }

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function editTechnicalDataFromId(id, data) {
  return baseEditFromId('services', id, data, 'technical_data');
}

/**
* Edit a single service based on his ID
*
* @param id the of the service requested
* @param data the new data of the service
*/
export function editPublicTechnicalDataFromId(id, data) {
 return baseEditFromId('services', id, data, 'public_technical_data');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function editContractsFromId(id, data) {
  return baseEditFromId('services', id, data, 'contract');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function editPhonePackageApiFromId(id, data) {
  return baseEditFromId('services', id, data, 'phone_package_api');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function editSpecificPhonePriceListFromId(id, data) {
  return baseEditFromId('services', id, data, 'specific_phone_price_list');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function editNewAmendmentFromId(id, data) {
  return baseEditFromId('services', id, data, 'new_amendment');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function editNewAmendmentServicePriceFromId(id, data) {
  return baseEditFromId('services', id, data, 'new_amendment_service_price');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function editNewRelocationFromId(id, data) {
  return baseEditFromId('services', id, data, 'new_relocation');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function editCentreonConfigurationFromId(id, data) {
  return baseEditFromId('services', id, data, 'centreon_configuration');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function editPhoneSystemReportingConfigurationFromId(id, data) {
  return baseEditFromId('services', id, data, 'phone_system_reporting_configuration');
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new service
 *
 * @param data the new data of the partner
 */
export function newItem(data) {
  return baseNewItem('services', data);
}

/******************************************************************************
 * TRANSITION FUNCTION                                                        *
 ******************************************************************************/

/**
 *
 */
export function disableTransition(id, data) {
  return baseTransitionFromId('services', id, data, 'disable');
}

/**
 *
 */
export function waitTerminationTransition(id, data) {
  return baseTransitionFromId('services', id, data, 'wait_termination');
}

/**
 *
 */
export function unwaitTerminationTransition(id, data) {
  return baseTransitionFromId('services', id, data, 'unwait_termination');
}

/**
 *
 */
export function terminationTransition(id, data) {
  return baseTransitionFromId('services', id, data, 'termination');
}

/**
 *
 */
export function scheduleTerminationTransition(id, data) {
  return baseTransitionFromId('services', id, data, 'schedule_termination');
}

/**
 *
 */
export function unscheduleTerminationTransition(id, data) {
  return baseTransitionFromId('services', id, data, 'unschedule_termination');
}

/**
 *
 */
export function cancelTerminationTransition(id, data) {
  return baseTransitionFromId('services', id, data, 'cancel_termination');
}

/**
 *
 */
export function terminatedTransition(id, data) {
  return baseTransitionFromId('services', id, data, 'terminated');
}

/**
 *
 */
export function terminatedNoBillTransition(id, data) {
  return baseTransitionFromId('services', id, data, 'terminated_no_bill');
}

/******************************************************************************
 * STATISTIC FUNCTION                                                         *
 ******************************************************************************/

export function statistic(stat, attribute, search) {
  return baseStatistic('services', stat, attribute, search);
}

/******************************************************************************
 * STATE MACHINE STATISTIC FUNCTION                                           *
 ******************************************************************************/

export function stateMachineStatistic(stateStatistic, states, search) {
  return baseStateMachineStatistic('services', stateStatistic, states, search);
}


/******************************************************************************
 * EXPORT FUNCTION                                                            *
 ******************************************************************************/

/**
 * export all service depending on search
 *
 * @param data the new data of the partner
 */
export function phoneExportData(search){
  let finalSearch = {};
  if(search) {
    Object.assign(finalSearch, search);
  }
  Object.assign(finalSearch, {
    state: "active,termination_waiting,termination_scheduled,termination",
    phone_package_order: true
  })
  return request('/services/export/phone_service_extract', 'GET', finalSearch);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all family to serve in a dropdown form choice
 */
export function fetchServices(search) {
  return baseIndex('services', 1, 0, search);
}

/******************************************************************************
 * SPECIFIC FUNCTION                                                          *
 ******************************************************************************/

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function addPhonePackage(id, data) {
  return baseEditFromId('services', id, data, 'phone_package_order');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function activatePhonePackageOrder(id, phonePackageOrderId) {
  let data = {
    id: id,
    phone_package_order: {
      id: phonePackageOrderId,
      active: true
    }
  }
  return baseEditFromId('services', id, data, 'phone_package_order_activation');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function deactivatePhonePackageOrder(id, phonePackageOrderId) {
  let data = {
    id: id,
    phone_package_order: {
      id: phonePackageOrderId,
      active: false
    }
  }
  return baseEditFromId('services', id, data, 'phone_package_order_activation');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function removeLastBill(id) {
  let data = {
    id: id,
    last_bill: true
  }
  return baseEditFromId('services', id, data, 'last_bill');
}

/**
 * Edit a single service based on his ID
 *
 * @param id the of the service requested
 * @param data the new data of the service
 */
export function reactivateLastBill(id) {
  let data = {
    id: id,
    last_bill: false
  }
  return baseEditFromId('services', id, data, 'last_bill');
}
